import { Modal, Box, Typography, Button, IconButton } from '@mui/material';
import { RedTheme } from 'common/global';
import CloseIcon from '@mui/icons-material/Close';
import { useScreen } from 'common/hooks/useScreen';

export const DeletePopup = ({
  open,
  handleClose,
  popupHeader,
  SubHeader,
  leftBtnText,
  rightBtnText,
  deleteFilterName,
  handleFavDelete,
}) => {
  let redtheme = RedTheme;
  const screen = useScreen();

  return (
    <>
      <Modal open={open}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: redtheme.palette.box.white,
            padding: screen.isMobile ? '24px' : '32px',
            display: 'flex',
            flexDirection: 'column',
            width: screen.isMobile ? '90vw' : '500px',
            minHeight: '250px',
            maxHeight: '90vh',
            borderRadius: '16px',
            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
          }}
        >
          <IconButton
            className='btn-close-popup'
            sx={{
              width: '24px',
              height: '24px',
              position: 'absolute',
              top: '16px',
              right: '16px',
              padding: 0,
            }}
            onClick={handleClose}
          >
            <CloseIcon sx={{ fontSize: '20px' }} />
          </IconButton>

          {/* Header */}
          <Box sx={{ marginTop: '8px', marginBottom: '16px' }}>
            <Typography
              component='h4'
              variant='h4'
              sx={{
                fontSize: screen.isMobile ? '24px' : '28px',
                lineHeight: screen.isMobile ? '30px' : '36px',
                fontWeight: 700,
                fontFamily: '"JohnsonDisplay-Bold"',
                wordWrap: 'break-word',
                paddingRight: '32px',
              }}
            >
              {popupHeader}
            </Typography>
          </Box>

          {/* Subheader */}
          <Box sx={{ marginBottom: '32px', flex: 1 }}>
            <Typography
              sx={{
                fontSize: '16px',
                lineHeight: '25px',
                fontWeight: 500,
                fontFamily: '"JohnsonText-Bold"',
                color: redtheme.palette.fontColor.gray_orange,
                wordWrap: 'break-word',
                paddingRight: '8px',
                whiteSpace: 'pre-line',
              }}
            >
              {SubHeader}
            </Typography>
          </Box>

          {/* Buttons */}
          <Box
            sx={{
              display: 'flex',
              gap: '12px',
              width: '100%',
              marginTop: 'auto',
            }}
          >
            <Button
              onClick={handleClose}
              sx={{
                fontWeight: 500,
                fontSize: '16px',
                lineHeight: '16px',
                flex: 1,
                height: '44px',
                borderRadius: '8px',
                fontFamily: '"JohnsonText-Medium"',
                textTransform: 'none',
                border: `1px solid ${redtheme.palette.text.primary}`,
                color: redtheme.palette.text.primary,
                backgroundColor: 'transparent',
                '&:hover': {
                  bgcolor: 'rgba(0, 0, 0, 0.04)',
                },
              }}
            >
              {leftBtnText}
            </Button>
            <Button
              onClick={() => {
                handleFavDelete(deleteFilterName);
                handleClose();
              }}
              sx={{
                fontWeight: 500,
                fontSize: '16px',
                lineHeight: '16px',
                flex: 1,
                height: '44px',
                borderRadius: '8px',
                fontFamily: '"JohnsonText-Medium"',
                textTransform: 'none',
                color: redtheme.palette.button.white,
                bgcolor: redtheme.palette.primary.main,
                '&:hover': {
                  bgcolor: redtheme.palette.primary.dark || redtheme.palette.primary.main,
                  opacity: 0.9,
                },
              }}
              variant='primary'
            >
              {rightBtnText}
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};
